
<script>
    import PreviewNodeState from "../mixins/PreviewNodeState";
    import Element from "../../components/pagesbuilder/elements/Element";    
    import PreviewVisibilityMixin from "@/author/pagesbuilder/mixins/PreviewVisibilityMixin";

    export default {
        name: "PreviewElement",
        mixins: [PreviewVisibilityMixin, PreviewNodeState, Element],
        data () {
            return {
                linksEnabled : true
            }
        },
        methods: {
            elementContextBindingFinished () {
                this.acquireElementData();
                this.elementCreationCallback();
                this.checkAnimationTrigger();
                if (this.checkVisibility) {
                    this.checkVisibility();
                }
            },
        }
    }
</script>
